/**
 * Seeded once from grantable-paths.json and discovery E2 on 2026-10-08; edit by hand from here.
 *
 * Data Security: the four data-driven families the reporting service resolves (E9), plus the two
 * report data tables the test report tags. The family universes mirror the reporting service's
 * `COMBO_BOX_UNIVERSE_QUERIES` (reports/framework/combo_box_universe.py).
 */
import { dataSecurityRoot } from '../builder';
import { family } from '../family';

export const dataSecurity = dataSecurityRoot();

export const revenueReportsTable = dataSecurity.dataTable('Data Table: RevenueReports');
export const title31RestrictedTable = dataSecurity.dataTable('Data Table: Title31Restricted');

export const departmentFamily = family('Department', {
  universe: { kind: 'sql', source: 'Select [Name] From dbo.Department With (NoLock)', column: 'Name', connection: 'CasinoManagerConnection' },
});

export const poolNameFamily = family('Pool Name', {
  universe: {
    kind: 'sql',
    source:
      "Select [Description] From dbo.DepositCategories With (NoLock) Where DepositCategoryTypeId = '52EC6CD8-C0A3-4169-BF1C-0141383CEFD4'",
    column: 'Description',
    connection: 'CasinoManagerConnection',
  },
});

export const siteFamily = family('Site', {
  universe: {
    kind: 'storedProcedure',
    source: 'dbo.spComboBox_Security_AnalyticsSite',
    column: 'ValueName',
    connection: 'BMDWDataWarehouseConnection',
  },
});

export const dataFamily = family('Data', {
  universe: {
    kind: 'comboBox',
    source:
      "Select ComboBoxItem.[ValueName] From dbo.ComboBox Inner Join dbo.ComboBoxItem On ComboBoxItem.ComboBoxId = ComboBox.Id Where ComboBox.[Name] = 'AnalyticsData' And ComboBox.IsDataDrivenSecurityEnabled = 1",
    column: 'ValueName',
    connection: 'CasinoManagerConnection',
  },
});
